import type { ActivatedRouteSnapshot } from '@angular/router';
import type { SignInMethods, SignUpMethods } from '@features/partners/builder/settings/sign-methods/models/sign-method';
import type { Observable } from 'rxjs';

import { inject } from '@angular/core';
import { SignMethodsWebservice } from '@features/partners/builder/settings/sign-methods/services/sign-methods.webservice';
import { forkJoin } from 'rxjs';

export interface SignMethodsData {
  signInMethods: SignInMethods;
  signUpMethods: SignUpMethods;
}

export const signMethodsResolver = (route: ActivatedRouteSnapshot): Observable<SignMethodsData> => {
  const signMethodsWebservice = inject(SignMethodsWebservice);
  const partnerId = route.paramMap.get('partnerId')!;

  return forkJoin({
    signInMethods: signMethodsWebservice.getSignInMethods(partnerId),
    signUpMethods: signMethodsWebservice.getSignUpMethods(partnerId),
  });
};
